export { default } from "./InputSelect"
